import { Scene, Sun, Environment, ItemManager, Cameras } from "../base";
import { WebCadEnvironment } from "./View3dWebCadEnviron";

/* WebCadScene
 * WebCad用のシーンクラス.
 */
export class WebCadScene extends Scene {
    private _exLights: Sun[];
    public get exLights(): Sun[] { return this._exLights; }

    public get wcEnvironment(): WebCadEnvironment { return <WebCadEnvironment>(this.environment); }
    constructor() {
        super();
        this._exLights = [];

        //追加の無限遠光源の作成.
        let dLight: Sun = new Sun(0xfffffd, 0, false);
        // let dLight: Sun = new Sun(0xfffffd, 0.6, false);
        dLight.position.set(5.0, 6.0, -8.0);
        this.me.add(dLight.me);
        this._exLights.push(dLight);
    }
    public createEnvironment(): Environment {
        return new WebCadEnvironment;
    }
    public update(items: ItemManager, cameras: Cameras, timeStamp: number) {
        ;
    }
}
